export default "https://cdn-gra-staging.amplement.io/statics/images/placeholder/placeholderList@2x.png";